import LancamentoIndex from './LancamentoIndex'

export const lancamentoRoutes = [
  {
    name: 'lancamento-index',
    path: '/lancamento',
    component: LancamentoIndex
  }
]
